import type { AnchorHTMLAttributes, ReactNode } from "react";

export interface AppLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  current?: boolean;
}

export const AppLink = ({
  href,
  children,
  current = false,
  ...props
}: AppLinkProps) => (
  <a href={href} aria-current={current ? "page" : undefined} {...props}>
    {children}
  </a>
);
